import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ThemeProvider } from "./contexts/ThemeContext";
import "slick-carousel/slick/slick.css";
import "./styles/responsive.css";
import "./styles/theme.css";
import "./styles/slider.css";
import "./App.css";

const LandingPage = React.lazy(() => import("./components/LandingPage"));
const About = React.lazy(() => import("./components/pages/About"));
const Services = React.lazy(() => import("./components/pages/Services"));
const Contact = React.lazy(() => import("./components/pages/Contact"));
const Portfolio = React.lazy(() => import("./components/pages/Portfolio"));
const CaseStudy = React.lazy(() => import("./components/pages/CaseStudy"));
const RetailSalesCaseStudy = React.lazy(() => import("./components/pages/RetailSalesCaseStudy"));

const DynamicTitle = ({ title }) => {
  useEffect(() => {
    document.title = title || "Paul Carter | Software Developer";
  }, [title]);

  return null;
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app-shell">
          <Header />
          <main className="page-main">
            <Suspense fallback={<div className="portfolio-container section">Loading...</div>}>
              <Routes>
                <Route
                  path="/"
                  element={
                    <>
                      <DynamicTitle title="Home | Paul Carter" />
                      <LandingPage />
                    </>
                  }
                />
                <Route
                  path="/about"
                  element={
                    <>
                      <DynamicTitle title="About | Paul Carter" />
                      <About />
                    </>
                  }
                />
                <Route
                  path="/contact"
                  element={
                    <>
                      <DynamicTitle title="Contact | Paul Carter" />
                      <Contact />
                    </>
                  }
                />
                <Route
                  path="/services"
                  element={
                    <>
                      <DynamicTitle title="Services | Paul Carter" />
                      <Services />
                    </>
                  }
                />
                <Route
                  path="/portfolio"
                  element={
                    <>
                      <DynamicTitle title="Portfolio | Paul Carter" />
                      <Portfolio limit={null} />
                    </>
                  }
                />
                <Route
                  path="/case-study"
                  element={
                    <>
                      <DynamicTitle title="Portfolio Case Study | Paul Carter" />
                      <CaseStudy />
                    </>
                  }
                />
                <Route
                  path="/case-study/retail-sales-analytics"
                  element={
                    <>
                      <DynamicTitle title="Retail Sales Analytics Case Study | Paul Carter" />
                      <RetailSalesCaseStudy />
                    </>
                  }
                />
                <Route
                  path="*"
                  element={
                    <>
                      <DynamicTitle title="Page Not Found | Paul Carter" />
                      <section className="section">
                        <div className="portfolio-container page-header">
                          <p className="section-kicker">404</p>
                          <h1 className="section-title-sm">Page not found</h1>
                          <p className="section-copy">The page you are looking for does not exist.</p>
                        </div>
                      </section>
                    </>
                  }
                />
              </Routes>
            </Suspense>
          </main>
          <Analytics />
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
